var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ReisenViewNav',{attrs:{"reisekuerzel":_vm.reisekuerzel}}),_c('router-view',{attrs:{"isBusy":_vm.isBusy,"isInitialLoading":_vm.isInitiallyLoading,"reise":_vm.reise},on:{"reiseUpdated":_vm.onReiseUpdated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }